import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendAudienceTarget,
  BackendMutationAddAudienceTargetArgs,
} from 'src/types/backend';

import { FRAGMENT_AUDIENCE_TARGET } from './schema';

const MUTATION = gql`
  mutation CreateAudienceTargeting(
    $projectId: Int!
    $targetType: AudienceTargetType!
    $targetEvaluation: AudienceTargetEvaluation
    $value: String
    $keywords: [String!]
  ) {
    addAudienceTarget(
      projectId: $projectId
      targetType: $targetType
      targetEvaluation: $targetEvaluation
      value: $value
      keywords: $keywords
    ) {
      ...AudienceTarget
    }
  }
  ${FRAGMENT_AUDIENCE_TARGET}
`;

type Variables = BackendMutationAddAudienceTargetArgs;
type Result = BackendAudienceTarget;

export const createAudienceTargeting = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
